//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// suggested-times imports
import { styles } from "./MoreButton.styles";
// material-ui
import { Button } from "@material-ui/core";
import { ExpandLess } from "@material-ui/icons";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

//////////////////
// TYPES
//////////////////
interface IProps extends WithStyles<typeof styles> {
  expanded: boolean;
  onClick: () => void;
  label?: string;
}

//////////////////
// COMPONENT
//////////////////
const MoreButtonCmpt = (props: IProps) => {
  const label = props.label || (props.expanded ? "Hide" : "View");
  return (
    <Button className={props.classes.moreButton} onClick={() => props.onClick()}>
      <span>{label}</span>
      <ExpandLess
        className={props.expanded ? props.classes.moreIcon : props.classes.moreIconLess}
      />
    </Button>
  );
};

//////////////////
// STYLE
//////////////////
export const MoreButton = withStyles(styles)(MoreButtonCmpt);
